/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualMaterialDto } from '../../models/backend-actual-material-dto';
import { BackendPatchedActualMaterialRequestDto } from '../../models/backend-patched-actual-material-request-dto';

export interface MonitoringActualsMaterialsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualMaterialRequestDto;
}

export function monitoringActualsMaterialsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsMaterialsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsMaterialsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualMaterialDto>;
    }),
  );
}

monitoringActualsMaterialsPartialUpdate$FormData.PATH = '/api/monitoring/actuals/materials/{id}/';
